import { getGraphqlClient } from "@/api/graphql/client.ts";
import type { MiddleMsResynchronisationRequest } from "@/api/graphql/types/graphql.ts";

import { resynchronisationMutation } from "./queries";

export const resynchronise = async ({
  customerAccountNumbers,
  type,
}: MiddleMsResynchronisationRequest) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(resynchronisationMutation, {
    request: {
      customerAccountNumbers,
      type,
    },
  });
};
